import { ExportCsvButton } from "../data/ExportCsvButton";
import type { ExportTable } from "../types";
import { useReportParams } from "./useReportParams";

/** Export button bound to the current URL filters (admin only, audited). */
export const ExportFromParams = ({ table }: { table: ExportTable }) => {
  const { from, to, filters } = useReportParams();
  return (
    <ExportCsvButton table={table} from={from} to={to} filters={filters} />
  );
};
